import { useTranslation } from "react-i18next";
import { NeuSelect } from "../../components/neu/Neu";
import { BranchChips } from "../../components/neu/BranchChips";
import { Field } from "../../components/neu/Field";
import { YesNo } from "./branch/Chip";
import { SubHeading } from "./EmployeeFormSection";
import { PermsButton } from "../permissions/PermsButton";
import { useAuth } from "../../context/AuthContext";
import { isCompanyAdmin } from "../../utils/role";

const ALL_ROLES = ["company_admin", "system_admin", "branch_manager", "employee"];
const EMP_TYPES = ["employee", "worker"];

export const EmployeeJobFields = ({ form, setField, branches, toggleBranch, userId }) => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const isOwner = isCompanyAdmin(user);
  const targetIsOwner = form.role === "company_admin";
  // القاعدة: تغيير الدور حصراً لمدير الشركة، ولا يُنزَّل المالك ولا يُرَقَّى موظف إلى مالك من هذا المكان.
  const roleDisabled = !isOwner || targetIsOwner;
  const roleOptions = ALL_ROLES.filter((r) => r !== "company_admin" || targetIsOwner);
  return (
    <>
      <SubHeading title={t("employees.form.sub.identity")} testId="sub-identity" />
      <Field label={t("employees.name")} testId="employee-name" value={form.name} onChange={(v) => setField("name", v)} autoLang="en" onAuto={(v) => setField("name_ar", v)} required />
      <Field label={t("employees.nameAr")} testId="employee-name-ar" value={form.name_ar} onChange={(v) => setField("name_ar", v)} autoLang="ar" onAuto={(v) => setField("name", v)} />
      <Field label={t("employees.jobTitle")} testId="employee-job" value={form.job_title} onChange={(v) => setField("job_title", v)} />
      <Field label={t("detail.phone")} testId="employee-phone" value={form.phone} onChange={(v) => setField("phone", v)} />

      <SubHeading title={t("employees.form.sub.pay")} testId="sub-pay" />
      <Field label={t("employees.salary")} testId="employee-salary" type="number" value={form.basic_salary} onChange={(v) => setField("basic_salary", v)} />
      {["housing", "transport", "other"].map((key) => (
        <Field
          key={key}
          label={t(`employees.allowance.${key}`)}
          testId={`employee-allowance-${key}`}
          type="number"
          value={form.allowances[key]}
          onChange={(v) => setField("allowances", { ...form.allowances, [key]: Number(v || 0) })}
        />
      ))}

      <SubHeading title={t("employees.form.sub.access")} testId="sub-access" />
      <div>
        <p className="label-xs mb-2">{t("employees.employmentType")}</p>
        <NeuSelect data-testid="employee-employment-type" value={form.employment_type} onChange={(e) => setField("employment_type", e.target.value)}>
          {EMP_TYPES.map((r) => (
            <option key={r} value={r}>{t(`employmentType.${r}`)}</option>
          ))}
        </NeuSelect>
      </div>
      <div>
        <p className="label-xs mb-2">{t("employees.role")}</p>
        <NeuSelect data-testid="employee-role" value={form.role} disabled={roleDisabled}
                   onChange={(e) => setField("role", e.target.value)}>
          {roleOptions.map((r) => (
            <option key={r} value={r}>{t(`roles.${r}`)}</option>
          ))}
        </NeuSelect>
        {roleDisabled ? (
          <p className="mt-1 text-[11px] text-muted-foreground" data-testid="role-lock-hint">
            {targetIsOwner ? t("employees.roleLockedOwner") : t("employees.roleLockedNonOwner")}
          </p>
        ) : null}
      </div>
      <div>
        <p className="label-xs mb-2">{t("employees.workMode")}</p>
        <NeuSelect data-testid="employee-work-mode" value={form.work_mode || "onsite"} onChange={(e) => setField("work_mode", e.target.value)}>
          <option value="onsite">{t("employees.workModeOnsite")}</option>
          <option value="remote">{t("employees.workModeRemote")}</option>
        </NeuSelect>
        <p className="mt-1 text-[11px] text-muted-foreground" data-testid="work-mode-hint">{t("employees.workModeHint")}</p>
      </div>
      <YesNo label={t("employees.allowWeekendWork")} testId="employee-allow_weekend_work" value={!!form.allow_weekend_work} onChange={(v) => setField("allow_weekend_work", v)} />
      {form.role === "branch_manager" ? (
        <YesNo label={t("employees.branchAbsolute")} testId="employee-branch_absolute"
               value={form.branch_absolute !== false} onChange={(v) => setField("branch_absolute", v)} />
      ) : null}
      {form.role === "branch_manager" ? (
        <p className="label-xs sm:col-span-2 lg:col-span-3 -mt-1 !font-normal text-muted-foreground" data-testid="branch-absolute-hint">
          {form.branch_absolute !== false ? t("employees.branchAbsoluteHint") : t("employees.branchCustomHint")}
        </p>
      ) : null}
      {userId && !["company_admin", "system_admin", "admin"].includes(form.role)
        && (form.role !== "branch_manager" || form.branch_absolute === false) ? (
        <div className="flex items-end">
          <PermsButton userId={userId} userName={form.name} />
        </div>
      ) : null}
      <div className="sm:col-span-2 lg:col-span-3">
        <p className="label-xs mb-2">{t("employees.branches")}</p>
        <BranchChips branches={branches} selected={form.branch_ids} onToggle={toggleBranch} prefix="employee-branch" />
      </div>
    </>
  );
};

